import React, { useEffect, useState } from "react";
import { MixPanel } from "../../shared/MixPanel/MixPanel";
// import { capitalizeFirstLetter } from "../../../helpers/capitalizeFirstLetter";

const ManageSignatoriesModal = ({
  properties: { dataRecord },
  onCloseModal,
}) => {
  const {
    action,
    type,
    signatoryRequest: { aggregator_id },
  } = dataRecord;
  const [comment, setComment] = useState("");

  const manageSettings = () => {
    onCloseModal();
    setTimeout(() => {
      action(aggregator_id, comment);
    }, 100);
  };

  useEffect(() => {
    MixPanel.track(`Page View: ManageSignatories.tsx`, {
      page: "ManageSignatories.tsx",
    });
  }, []);

  return (
    <div className="Modal__dialog animated slideInDown" role="document">
      <div
        className="AuditTrailModal Modal__content"
        style={{ overflow: "hidden" }}
      >
        <div className="Modal__body">
          <h2 className="Modal__title p-b-2 text-center font-weight-bold">
            {type} Signatory
          </h2>
          <h5 className="text-center">
            Are you sure you want to {type.toLowerCase()} signatory ?
          </h5>
          <hr />
          <form>
            <div className="row">
              <div className="col-12 mb-1">
                <label>Comment</label>
                <input
                  type="text"
                  className="form-control"
                  name="comment"
                  defaultValue={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></input>
              </div>
              <div className="col-12 d-flex justify-content-end flex-wrap">
                <button
                  className="btn advancly-nobg-btn btn-sm transition-3d-hover mt-2 mr-2"
                  type="button"
                  onClick={onCloseModal}
                >
                  Cancel
                </button>
                <button
                  className="btn advancly-btn btn-sm transition-3d-hover mt-2"
                  type="submit"
                  disabled={!comment}
                  onClick={manageSettings}
                >
                  {type}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ManageSignatoriesModal;
